import { useClassNames } from '@magnetic/hooks';
import DOMPurify from 'dompurify';
import React, { forwardRef } from 'react';
import { useCodeToHtml } from './use-code-to-html.js';
import '@magnetic/theme';
import './style.css.js';

const Block = forwardRef(
  ({
    actionBar,
    children,
    fontSize = "md",
    height,
    language = "text",
    lineNumbers = false,
    width,
    ...rest
  }, ref) => {
    const { digits, html } = useCodeToHtml(children, {
      language,
      lineNumbers
    });
    const style = {
      ...height && { height },
      ...width && { width },
      "--mds-line-digit-length": digits
    };
    const classNames = useClassNames("mds-code-block-container", {
      "mds-code-block-border": language !== "text" || actionBar
    });
    const codeBlockClassNames = useClassNames("mds-code-block", {
      "mds-code-block-with-cta": actionBar
    });
    const safeHtml = DOMPurify.sanitize(html);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames,
        "data-size": fontSize,
        "data-testid": "code-block-container",
        ref,
        style,
        ...rest
      },
      actionBar && /* @__PURE__ */ React.createElement("div", { className: "mds-call-to-action" }, actionBar),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: codeBlockClassNames,
          dangerouslySetInnerHTML: { __html: safeHtml },
          "data-testid": "code-block"
        }
      )
    );
  }
);
Block.displayName = "Code.Block";

export { Block };
//# sourceMappingURL=index.js.map
